//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class ExternalEventSearchOptions extends ItemBase {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    StartTime: string | null = null;
    EndTime: string | null = null;
    EventIDs: string[] = [];
    TeacherIDs: string[] = [];
    AllDay: boolean | null = null;
    Busy: boolean | null = null;

    constructor(initializer?: Partial<ExternalEventSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ExternalEventSearchOptions";
}
